import MainCatalogsEditorBase from '../MainCatalogsEditorBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './FunctionalGroupEditor.html?raw';
import on from 'dojo/on';
import Edit from '../../../moreCore/UI/Edit/Edit';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import FunctionalSubGroupEntry from './FunctionalSubGroup/FunctionalSubGroupEntry';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import { MainCatalogSelect } from '../MainCatalogEditorTools';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";

class FunctionalGroupEditor extends compose(MainCatalogsEditorBase) {
    templateString: any = template;


    functionalSubGroupContainer: HTMLElement;

    fg_Input_Code: MdsLax<InstanceType<typeof Edit>>;
    fg_Input_Description: MdsLax<InstanceType<typeof Edit>>;
    fg_Input_TextColor: HTMLInputElement;
    fg_Input_BackgroundColor: HTMLInputElement;
    fg_Input_Order: MdsLax<InstanceType<typeof NumberInput>>;

    fg_Input_NumberOfLines: MdsLax<InstanceType<typeof NumberInput>>;
    dt_Checkbox_UsedForWeekplaning: MdsLax<InstanceType<typeof CheckBox>>;

    fg_Select_MainGroup: MdsLax<InstanceType<typeof MainCatalogSelect>>;

    allSubGroupsEntries: Array<MdsLax<InstanceType<typeof FunctionalSubGroupEntry>>>;

    functionalSubGroupButtonAdd: HTMLButtonElement;

    formData: MainCatalogTypes.FunctionalGroup_SaveData = {
        ID: "",
        is_new_status: null,
        code: "",
        description: "",
        order: null,
        coloration: null,
        functional_main_group_id: "",
        number_of_lines: null,
        is_used_for_weekplaning: null,
        functional_sub_group_list: []
    };

    prepareFormData(data?: MainCatalogTypes.FunctionalGroup_LoadData): void {

        let mainGroupId: string = null;

        this.allSubGroupsEntries = new Array<MdsLax<InstanceType<typeof FunctionalSubGroupEntry>>>();
        this.UiModder.domConstruct.empty(this.functionalSubGroupContainer);

        if (data) {

            this.fg_Input_Code.setValue(data.code, true);
            this.fg_Input_Description.setValue(data.description_D, true);

            this.fg_Input_TextColor.value = data.coloration.TextColor.Hex;
            this.fg_Input_BackgroundColor.value = data.coloration.BackColor.Hex;

            this.fg_Input_Order.setValue(data.order, true);

            this.fg_Input_NumberOfLines.setValue(data.number_of_lines, true);
            this.dt_Checkbox_UsedForWeekplaning.setValue(data.is_used_for_weekplaning, true);
            if (data.is_used_for_weekplaning) this.UiModder.domClass.remove(this.fg_Input_NumberOfLines.domNode, "w3-disabled");
            else this.UiModder.domClass.add(this.fg_Input_NumberOfLines.domNode, "w3-disabled");

            this.fg_Select_MainGroup.setCatalog(MainCatalogs_Classes.FunctionalMainGroup,
                this.translations["General_Label_FunctionalMainGroup"], true, data.ref_functional_main_group.ID);

            mainGroupId = data.ref_functional_main_group.ID;

            data.EL_functional_sub_group_functional_group.forEach(sub => {

                let entry = new FunctionalSubGroupEntry();
                entry.setEntry(false, sub);
                entry.placeAt(this.functionalSubGroupContainer);
                on(entry, "FunctionalSubGroup_SerializeData", lang.hitch(this, this._onChangeInputDataGeneric));

                this.UiModder.domClass.add(entry.domNode, "accentOutline round w3-margin")

                this.allSubGroupsEntries.push(entry);
            });

            this.formData.ID = data.ID;
            this.formData.is_new_status = false;
        } else {

            this.fg_Input_Code.setValue("", true);
            this.fg_Input_Description.setValue("", true);

            this.fg_Input_BackgroundColor.value = "#ffffff";
            this.fg_Input_TextColor.value = "#000000";

            this.fg_Input_Order.setValue(null, true);

            this.fg_Input_NumberOfLines.setValue(null, true);
            this.UiModder.domClass.add(this.fg_Input_NumberOfLines.domNode, "w3-disabled");
            this.dt_Checkbox_UsedForWeekplaning.setValue(false, true);

            this.fg_Select_MainGroup.setCatalog(MainCatalogs_Classes.FunctionalMainGroup,
                this.translations["General_Label_FunctionalMainGroup"], true);
            this.fg_Select_MainGroup.setValue(null);

            this.formData.ID = "";
            this.formData.is_new_status = true;
        }

        this.serializeFormData(mainGroupId);
        this.originalData = JSON.stringify(this.formData);
        console.debug("ORIGINAL", this.originalData);
        this.StandbyStop();

        this.checkDirty();
    }

    serializeFormData(mainGroupId?: string): void {

        this.formData.code = this.fg_Input_Code.getValue();
        this.formData.description = this.fg_Input_Description.getValue();

        this.formData.order = this.fg_Input_Order.getValue();

        this.formData.number_of_lines = this.fg_Input_NumberOfLines.getValue();
        this.formData.is_used_for_weekplaning = this.dt_Checkbox_UsedForWeekplaning.getValue();

        let coloration: MainCatalogTypes.PIT_Coloration = {
            TextColor: null,
            BackColor: null
        };
        let textColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let backColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let textHex = this.fg_Input_TextColor.value;
        let backHex = this.fg_Input_BackgroundColor.value;

        textColor.Hex = textHex;
        textColor.Red = parseInt(textHex.slice(1, 3), 16);
        textColor.Green = parseInt(textHex.slice(3, 5), 16);
        textColor.Blue = parseInt(textHex.slice(5, 7), 16);

        backColor.Hex = backHex;
        backColor.Red = parseInt(backHex.slice(1, 3), 16);
        backColor.Green = parseInt(backHex.slice(3, 5), 16);
        backColor.Blue = parseInt(backHex.slice(5, 7), 16);

        coloration.TextColor = textColor;
        coloration.BackColor = backColor;

        this.formData.coloration = coloration;

        mainGroupId ? this.formData.functional_main_group_id = mainGroupId : this.formData.functional_main_group_id = this.fg_Select_MainGroup.getValue();

        this.formData.functional_sub_group_list = [];
        this.allSubGroupsEntries.forEach(sub => {

            this.formData.functional_sub_group_list.push(sub.formData);
        });

        console.debug("SERIALIZED DATA", this.formData);
    }

    isValid(): boolean {

        let b: boolean = true;
        let subNotValid: boolean = false;

        if (!this.formData.code) {

            this.indicateErrorOnInput(this.fg_Input_Code.inputNode);
            b = false;
        }

        if (!this.formData.description) {

            this.indicateErrorOnInput(this.fg_Input_Description.inputNode);
            b = false;
        }

        if (!this.formData.functional_main_group_id) {

            this.indicateErrorOnInput(this.fg_Select_MainGroup.domNode);
            b = false;
        }

        this.formData.functional_sub_group_list.forEach(sub => {

            if (!sub.is_to_delete && !sub.code) {

                subNotValid = true;
                b = false;
            }
            if (!sub.is_to_delete && !sub.description) {

                subNotValid = true;
                b = false;
            }
        });

        if (subNotValid) {

            this.allSubGroupsEntries.forEach(entry => {

                if (!entry.fsg_Input_Code.getValue() || !entry.fsg_Input_Description.getValue()) {

                    if (!entry.isToDelete) this.indicateErrorOnInput(entry.domNode);
                }
            });
        }

        return b;
    }

    _onClickButtonSubGroupButtonAdd(): void {

        let entry = new FunctionalSubGroupEntry();
        entry.setEntry(true);
        entry.placeAt(this.functionalSubGroupContainer);
        on(entry, "FunctionalSubGroup_SerializeData", lang.hitch(this, this._onChangeInputDataGeneric));
        on(entry, "FunctionalSubGroup_Destroy", lang.hitch(this, this._onDestroyFunctionalSubGroup, entry));

        this.UiModder.domClass.add(entry.domNode, "accentOutline round mds-bg-green w3-margin");

        this.allSubGroupsEntries.push(entry);

        this.serializeFormData();
        this.checkDirty();
    }

    _onDestroyFunctionalSubGroup(entry) {

        let index = this.allSubGroupsEntries.indexOf(entry);

        this.allSubGroupsEntries.splice(index, 1);

        this.serializeFormData();
        this.checkDirty();
    }

    _onChangeInputDataGeneric(): void {

        let b: boolean = this.dt_Checkbox_UsedForWeekplaning.getValue();

        if (b) {

            this.UiModder.domClass.remove(this.fg_Input_NumberOfLines.domNode, "w3-disabled");
        } else {

            this.UiModder.domClass.add(this.fg_Input_NumberOfLines.domNode, "w3-disabled");
            this.fg_Input_NumberOfLines.setValue(null, true);
        }
        super._onChangeInputDataGeneric.apply(this, arguments as any);
    }

    closeMainGroupEdit(): void {

        this.fg_Select_MainGroup.editForm?.close();
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.entityClass = MainCatalogs_Classes.FunctionalGroup;

        this.fg_Input_Code.setMaxLength(10);
        this.fg_Input_Description.setMaxLength(255);

        this.fg_Select_MainGroup.placeAt(this.editFormRightSection, "first");
        this.UiModder.domClass.add(this.fg_Select_MainGroup.domNode, "w3-margin-left w3-margin-right");
        on(this.fg_Select_MainGroup, "change", lang.hitch(this, this._onChangeInputDataGeneric));

        on(this, "MainCatalogSelect_ShowHideAddChange", lang.hitch(this, this.closeMainGroupEdit));
        on(this, "CatalogEntityData_Save", lang.hitch(this, this.closeMainGroupEdit));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(FunctionalGroupEditor.prototype, {
  fg_Input_Code: () => (new Edit()),
  fg_Input_Description: () => (new Edit()),
  fg_Input_Order: () => (new NumberInput()),
  fg_Input_NumberOfLines: () => (new NumberInput()),
  dt_Checkbox_UsedForWeekplaning: () => (new CheckBox()),
  fg_Select_MainGroup: () => (new MainCatalogSelect()),
});
export default mdsWidget(FunctionalGroupEditor);
